module.exports = __webpack_public_path__ + "static/media/Montserrat-BlackItalic.e70885e2.eot";